// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from "jquery";
import './script/owl.carousel';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}   
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();


// Add animation for a Searchbox
const headerSearchBox = document.querySelectorAll('.search-box ');
const headerSearchInput = document.querySelectorAll('.header-search-input');
headerSearchInput.forEach(input => input.addEventListener('focus', () => { 
	headerSearchBox.forEach(box => box.classList.add('focused'));
	})   
);
headerSearchInput.forEach(input => input.addEventListener('focusout', () => { 
	headerSearchBox.forEach(box => box.classList.remove('focused'));
	})   
);


// Add animation for a Languages dropdown MOBILE
const languagesMobile = document.querySelector('.mobile-languages');

document.body.addEventListener('click', (event) => { 

	// console.log(event.target)

	if (event.target.classList.contains('mobile-languages-switcher')) { 
		languagesMobile.classList.toggle('opened');
	} else {
		languagesMobile.classList.remove('opened');
	}	
});


const navLinks = document.querySelectorAll('.menu-item .nav-link');
const navbarToggler = document.querySelector('.navbar-toggler');
const navbar = document.querySelector('#navbar');

navLinks.forEach(navLink => {
  navLink.addEventListener("click", (event) => { 

	if (!navbarToggler.classList.contains('collapsed') && !(event.target.parentElement.contains('dropdown'))  ) { // && !(event.target.parentElement.contains('dropdown'))
		navbarToggler.classList.add('collapsed');
		navbar.classList.remove('collapsing');
		navbar.classList.remove('show');
	}    
  }) 
});



const dropdownToggles = document.querySelectorAll('.dropdown-toggle');

// dropdownToggles.forEach(dropdownToggle => dropdownToggle.addEventListener('click', (event) => {
	document.body.addEventListener('click', (event) => { 

	dropdownToggles.forEach(dropdownToggle => dropdownToggle.parentElement.classList.remove('expanded'));

		if(event.target.classList.contains('show')) {
			event.target.parentElement.classList.add('expanded');	
		} else {
			event.target.parentElement.classList.remove('expanded');	
		}		
	});


// Product carousel on home page
$('.product-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
	dots: false,
	lazyLoad: true,
    responsive:{
        0:{
            items:1
        },
        576:{
            items:2
        },
        768:{
            items:3
        },
        992:{
            items:4
        },
        1200:{
            items:5
        },
        1400:{
            items:6
        },
        1700:{
            items:7
        }
    }
})

// News carousel
$('.news-carousel').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
	dotsEach: true,
	nav: true,
	rewind: false,
    responsive:{
        0:{
            items:1
        },
		576:{
            items:2
        },
        992:{
            items:3
        },
    }
})

// Our strengths carousel
$('.our-strengths-carousel').owlCarousel({
    loop:true,
    margin:0,
    nav:true,
	dots: false,
    responsive:{
        0:{
            items:1
        },
        576:{
            items:2
        },
        768:{
            items:3
        },
        992:{
            items:4
        },
        1200:{
            items:5
        }
    }
})

// To-top BTN

const toTopBtn = document.querySelector('.to-top');
const footer = document.getElementById('footer');

function toTopScroll() {
	document.body.scrollTop = 0;
	document.documentElement.scrollTop = 0;
}

window.addEventListener('scroll', function() {
	if (screen.height >= footer.getBoundingClientRect().y) {

		console.log(document.body.scrollHeight)
		console.log(screen.height)
		console.log(footer.getBoundingClientRect().y)
		toTopBtn.style.bottom = '10%';
	  } else {
		toTopBtn.style.bottom = '-30%';
	  }
});

toTopBtn.addEventListener("click", toTopScroll);


// Add color to active menu item on Downloads page

const listContainerSticky = document.querySelector('.list-container-sticky');

window.addEventListener('scroll', () => {
	let scrollDistance = window.scrollY;

	if (window.innerWidth > 768) {
		document.querySelectorAll('.downloads-list-container').forEach((el, i) => {
			if (el.offsetTop - document.querySelector('.list-headers').clientHeight <= scrollDistance) {
				document.querySelectorAll('.aside-list-item-header-link').forEach((el) => {
					if (el.classList.contains('active')) {
						el.classList.remove('active');
					}
				});

				if(i < document.querySelectorAll('.aside-list-item-header').length) {
					document.querySelectorAll('.aside-list-item-header')[i].querySelector('a').classList.add('active');
				}
			}
		});

		// listContainerSticky.classList.add('sticky');
	} else {
		// listContainerSticky.classList.remove('sticky');
	}
});


$('.trainings-gallery-slider').owlCarousel({
    loop:true,
    margin:10,
    nav:true,
	dotsEach: true,
	rewind: false,
    responsive:{
        0:{
            items:1
        },
        600:{
            items:3
        },
        1000:{
            items:3 
        }
    }
})
